/**
 * index.tsx
 * [Readme] --------------------------------------------------------------------------------------
 *
 * (분양페이지용 탑배너)
 * 탑배너 표출에 대한 UI 컴포넌트입니다.
 * 서버로부터 기본 모델 정보를 전달받고 이를 표출하는데 사용됩니다.
 *
 * -----------------------------------------------------------------------------------------------
 */

import TopBanner from 'common-modules/general/Common/Components/TopBannerContainer/TopBanner';
import { useState, useEffect } from 'react';
import { setWithExpiry, getWithExpiry } from 'common-modules/general/Modules/functions';
import { useLocation } from 'react-router';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';

interface Props {
  isMobile: boolean;
  mainModel: any;
}

const TopBannerComponent = observer(({ isMobile, mainModel: topBannerModel }: Props) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isCloseToday, setIsCloseToday] = useState(true);
  const location = useLocation();
  const time = 86400000;

  useEffect(() => {
    topBannerModel.getData();
  }, [topBannerModel]);

  const topBannerInformation = toJS(topBannerModel.mainData.data?.banner);

  useEffect(() => {
    if (topBannerModel && topBannerModel.mainData.data?.banner) {
      const topBannerInformation = toJS(topBannerModel.mainData.data?.banner);
      if (topBannerInformation) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    }
  }, [topBannerModel]);

  const handleCloseToday = () => {
    setWithExpiry('isCloseTopBanner', 'true', time);
    setIsCloseToday(false);
  };

  const checkTopBanner = () => {
    const isCloseTopBanner = getWithExpiry('isCloseTopBanner');

    if (isCloseTopBanner && isCloseTopBanner === 'true') {
      setIsCloseToday(false);
    } else {
      setIsCloseToday(true);
    }
  };

  useEffect(() => {
    checkTopBanner();
  }, []);

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    const isHashRoot = hash === '/sales/' || hash === '/sales/exhbt' || hash === '/sales/location' || hash === '/' || hash === '';
    
    if (isHashRoot) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [location.hash]);

  useEffect(() => {}, []);

  const handleClickClose = () => {
    setIsOpen(false);
  };

  if (topBannerInformation) {
    const { urlMvmt, sralAtchMoFile, sralAtchPcFile, typeOpn, ynNewwdw, cntsBanr, typeGide } = topBannerInformation;

    return (
      <TopBanner
        isMobile={isMobile}
        isOpen={isOpen && isCloseToday}
        src={isMobile ? sralAtchMoFile : sralAtchPcFile}
        onCloseToday={handleCloseToday}
        onClose={handleClickClose}
        typeOpn={typeOpn}
        cntsBanr={cntsBanr}
        urlMvmt={urlMvmt}
        ynNewwdw={ynNewwdw}
        typeGide={typeGide}
      />
    );
  } else {
    return null;
  }
});

export default TopBannerComponent;
